var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white accent--text mb-5 mr-8",attrs:{"small":""},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v("Terug")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }